import type {FC, ReactNode} from 'react';

import {Observer} from 'mobx-react';

import type {TrackersStore} from '../../../../../stores/Trackers/Trackers.store';
import type {OnMoreIconClick} from '../../types';

import NoWeightSvg from '../../../../../../../../assets/icons/empty-state/no-weight.svg';
import MoreIcon from '../../../../../../../../assets/icons/secondary/More.svg';
import {NoResultsView} from '../../../../../../../../components/NoResultsView';
import {Button} from '../../../../../../../../uikit/Button';
import {Clickable} from '../../../../../../../../uikit/Clickable';
import {Icon} from '../../../../../../../../uikit/Icon';
import {LoadingSpinner} from '../../../../../../../../uikit/LoadingSpinner';
import {Text} from '../../../../../../../../uikit/Text';
import * as S from '../../styles';
import {TestID} from '../../test_ids';
import {Weight} from '../Weight';

type Props = {
  onAddWeightClick: () => void;
  onMoreCurrentWeightClick: (e: Parameters<OnMoreIconClick>[0]) => void;
  renderCurrentDate: (props: {store: TrackersStore}) => ReactNode;
  store: TrackersStore;
  t: (key: string) => string;
};

export const CurrentWeightBlock: FC<Props> = ({
  onAddWeightClick,
  onMoreCurrentWeightClick,
  renderCurrentDate,
  store,
  t,
}) => (
  <S.Block>
    <S.Row>
      <Text variant="h3" weight="bold">
        {t('shared:current_weight')}
      </Text>
      <S.DateContainer>{renderCurrentDate({store})}</S.DateContainer>
      <Clickable
        onClick={onMoreCurrentWeightClick}
        testID={TestID.button_more_current_weight}
      >
        <Icon color="icon.gray" svg={MoreIcon} />
      </Clickable>
    </S.Row>
    <Observer>
      {() => (
        <S.Weight>
          {store.isCurrentWeightBlockVisible ? (
            <>
              {store.currentWeight ? (
                <Weight
                  onClick={onAddWeightClick}
                  unit={store.currentWeight.unit}
                  weight={store.currentWeight.weight}
                />
              ) : null}
              {store.isTodayEmpty ? (
                <NoResultsView
                  icon={NoWeightSvg}
                  iconColor="icon.gray"
                  iconSize={100}
                  text={t('shared:please_add_your_weight')}
                />
              ) : null}
            </>
          ) : (
            <S.TextContainer>
              <S.TextWrapper>
                <Text variant="h3" weight="bold">
                  <span style={{whiteSpace: 'pre-line'}}>
                    {t('shared:success_quote')}
                  </span>
                </Text>
              </S.TextWrapper>
            </S.TextContainer>
          )}
          <Button.V2
            accentColor={
              store.isTodayEmpty ? 'static.accent.trackers' : 'background10'
            }
            onClick={onAddWeightClick}
          >
            {t(store.isTodayEmpty ? 'shared:add_weight' : 'shared:edit_weight')}
          </Button.V2>
          {store.isFetching ? <LoadingSpinner /> : null}
        </S.Weight>
      )}
    </Observer>
  </S.Block>
);
